export const CREATE_COMPLAINT = "CREATE_COMPLAINT";
export const FETCH_COMPLAINTS = "FETCH_COMPLAINTS";
export const FETCH_COMPLAINT = "FETCH_COMPLAINT";
export const EDIT_COMPLAINT = "EDIT_COMPLAINT";
export const DELETE_COMPLAINT = "DELETE_COMPLAINT";
